/* Table of Contents
==================================================

    #Slate Default
    #Custom Velstar

==================================================
*/

/* ==========================================================================
#Slate Default
========================================================================== */

window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Settings ================*/
//Create Vars that match SCSS breakpoints, defined in variables.scss.liquid file.
var screenSM = 576,
	screenMD = 768,
	screenLG = 992,
    screenXL = 1200;
    
var slickPrevArrow = "<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><svg class='icon-chevron' aria-hidden='true' data-prefix='fal' data-icon='chevron-left' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 512'><path d='M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z'></path></svg><svg class='icon-arrow' width='22px' height='13px' viewBox='0 0 22 13' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><g id='Mobile' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'><g id='Mobile-Homepage' transform='translate(-294.000000, -3292.000000)' stroke='#000000'><g id='Group-7' transform='translate(305.000000, 3298.500000) scale(-1, 1) translate(-305.000000, -3298.500000) translate(295.000000, 3293.000000)'><polyline id='Rectangle' transform='translate(14.427801, 5.500000) rotate(-45.000000) translate(-14.427801, -5.500000)' points='18.1059823 1.69818182 18.2296187 9.30181818 10.6259823 9.17818182'></polyline><path d='M19.8043834,5.5 L0,5.5' id='Path-2'></path></g></g></g></svg></button>",
    slickNextArrow = "<button class='slick-next slick-arrow' aria-label='Next' type='button'><svg class='icon-chevron' aria-hidden='true' data-prefix='fal' data-icon='chevron-right' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 512'><path d='M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z'></path></svg><svg class='icon-arrow' width='22px' height='13px' viewBox='0 0 22 13' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><g id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'><g id='Desktop-Footer-V5-About' transform='translate(-834.000000, -270.000000)' stroke='#000000'><g id='Group' transform='translate(552.000000, 165.000000)'><g id='Group-2' transform='translate(13.000000, 91.000000)'><g id='Group-7' transform='translate(270.000000, 15.000000)'><polyline id='Rectangle' transform='translate(14.427801, 5.500000) rotate(-45.000000) translate(-14.427801, -5.500000)' points='18.1059823 1.69818182 18.2296187 9.30181818 10.6259823 9.17818182'></polyline><path d='M19.8043834,5.5 L0,5.5' id='Path-2'></path></g></g></g></g></g></svg></button>";

    

//if no image available, load the SVG placeholder image. Generate by the liquid tag {{ 'product-1' | placeholder_svg_tag: 'svg-placeholder' }}
var svgPlaceholder = '<svg class="svg-placeholder" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M375.5 345.2c0-.1 0-.1 0 0 0-.1 0-.1 0 0-1.1-2.9-2.3-5.5-3.4-7.8-1.4-4.7-2.4-13.8-.5-19.8 3.4-10.6 3.6-40.6 1.2-54.5-2.3-14-12.3-29.8-18.5-36.9-5.3-6.2-12.8-14.9-15.4-17.9 8.6-5.6 13.3-13.3 14-23 0-.3 0-.6.1-.8.4-4.1-.6-9.9-3.9-13.5-2.1-2.3-4.8-3.5-8-3.5h-54.9c-.8-7.1-3-13-5.2-17.5-6.8-13.9-12.5-16.5-21.2-16.5h-.7c-8.7 0-14.4 2.5-21.2 16.5-2.2 4.5-4.4 10.4-5.2 17.5h-48.5c-3.2 0-5.9 1.2-8 3.5-3.2 3.6-4.3 9.3-3.9 13.5 0 .2 0 .5.1.8.7 9.8 5.4 17.4 14 23-2.6 3.1-10.1 11.7-15.4 17.9-6.1 7.2-16.1 22.9-18.5 36.9-2.2 13.3-1.2 47.4 1 54.9 1.1 3.8 1.4 14.5-.2 19.4-1.2 2.4-2.3 5-3.4 7.9-4.4 11.6-6.2 26.3-5 32.6 1.8 9.9 16.5 14.4 29.4 14.4h176.8c12.9 0 27.6-4.5 29.4-14.4 1.2-6.5-.5-21.1-5-32.7zm-97.7-178c.3-3.2.8-10.6-.2-18 2.4 4.3 5 10.5 5.9 18h-5.7zm-36.3-17.9c-1 7.4-.5 14.8-.2 18h-5.7c.9-7.5 3.5-13.7 5.9-18zm4.5-6.9c0-.1.1-.2.1-.4 4.4-5.3 8.4-5.8 13.1-5.8h.7c4.7 0 8.7.6 13.1 5.8 0 .1 0 .2.1.4 3.2 8.9 2.2 21.2 1.8 25h-30.7c-.4-3.8-1.3-16.1 1.8-25zm-70.7 42.5c0-.3 0-.6-.1-.9-.3-3.4.5-8.4 3.1-11.3 1-1.1 2.1-1.7 3.4-2.1l-.6.6c-2.8 3.1-3.7 8.1-3.3 11.6 0 .2 0 .5.1.8.3 3.5.9 11.7 10.6 18.8.3.2.8.2 1-.2.2-.3.2-.8-.2-1-9.2-6.7-9.8-14.4-10-17.7 0-.3 0-.6-.1-.8-.3-3.2.5-7.7 3-10.5.8-.8 1.7-1.5 2.6-1.9h155.7c1 .4 1.9 1.1 2.6 1.9 2.5 2.8 3.3 7.3 3 10.5 0 .2 0 .5-.1.8-.3 3.6-1 13.1-13.8 20.1-.3.2-.5.6-.3 1 .1.2.4.4.6.4.1 0 .2 0 .3-.1 13.5-7.5 14.3-17.5 14.6-21.3 0-.3 0-.5.1-.8.4-3.5-.5-8.5-3.3-11.6l-.6-.6c1.3.4 2.5 1.1 3.4 2.1 2.6 2.9 3.5 7.9 3.1 11.3 0 .3 0 .6-.1.9-1.5 20.9-23.6 31.4-65.5 31.4h-43.8c-41.8 0-63.9-10.5-65.4-31.4zm91 89.1h-7c0-1.5 0-3-.1-4.2-.2-12.5-2.2-31.1-2.7-35.1h3.6c.8 0 1.4-.6 1.4-1.4v-14.1h2.4v14.1c0 .8.6 1.4 1.4 1.4h3.7c-.4 3.9-2.4 22.6-2.7 35.1v4.2zm65.3 11.9h-16.8c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h16.8v2.8h-62.2c0-.9-.1-1.9-.1-2.8h33.9c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-33.9c-.1-3.2-.1-6.3-.1-9h62.5v9zm-12.5 24.4h-6.3l.2-1.6h5.9l.2 1.6zm-5.8-4.5l1.6-12.3h2l1.6 12.3h-5.2zm-57-19.9h-62.4v-9h62.5c0 2.7 0 5.8-.1 9zm-62.4 1.4h62.4c0 .9-.1 1.8-.1 2.8H194v-2.8zm65.2 0h7.3c0 .9.1 1.8.1 2.8H259c.1-.9.1-1.8.1-2.8zm7.2-1.4h-7.2c.1-3.2.1-6.3.1-9h7c0 2.7 0 5.8.1 9zm-7.7-66.7v6.8h-9v-6.8h9zm-8.9 8.3h9v.7h-9v-.7zm0 2.1h9v2.3h-9v-2.3zm26-1.4h-9v-.7h9v.7zm-9 3.7v-2.3h9v2.3h-9zm9-5.9h-9v-6.8h9v6.8zm-119.3 91.1c-2.1-7.1-3-40.9-.9-53.6 2.2-13.5 11.9-28.6 17.8-35.6 5.6-6.5 13.5-15.7 15.7-18.3 11.4 6.4 28.7 9.6 51.8 9.6h6v14.1c0 .8.6 1.4 1.4 1.4h5.4c.3 3.1 2.4 22.4 2.7 35.1 0 1.2.1 2.6.1 4.2h-63.9c-.8 0-1.4.6-1.4 1.4v16.1c0 .8.6 1.4 1.4 1.4H256c-.8 11.8-2.8 24.7-8 33.3-2.6 4.4-4.9 8.5-6.9 12.2-.4.7-.1 1.6.6 1.9.2.1.4.2.6.2.5 0 1-.3 1.3-.8 1.9-3.7 4.2-7.7 6.8-12.1 5.4-9.1 7.6-22.5 8.4-34.7h7.8c.7 11.2 2.6 23.5 7.1 32.4.2.5.8.8 1.3.8.2 0 .4 0 .6-.2.7-.4 1-1.2.6-1.9-4.3-8.5-6.1-20.3-6.8-31.1H312l-2.4 18.6c-.1.4.1.8.3 1.1.3.3.7.5 1.1.5h9.6c.4 0 .8-.2 1.1-.5.3-.3.4-.7.3-1.1l-2.4-18.6H333c.8 0 1.4-.6 1.4-1.4v-16.1c0-.8-.6-1.4-1.4-1.4h-63.9c0-1.5 0-2.9.1-4.2.2-12.7 2.3-32 2.7-35.1h5.2c.8 0 1.4-.6 1.4-1.4v-14.1h6.2c23.1 0 40.4-3.2 51.8-9.6 2.3 2.6 10.1 11.8 15.7 18.3 5.9 6.9 15.6 22.1 17.8 35.6 2.2 13.4 2 43.2-1.1 53.1-1.2 3.9-1.4 8.7-1 13-1.7-2.8-2.9-4.4-3-4.6-.2-.3-.6-.5-.9-.6h-.5c-.2 0-.4.1-.5.2-.6.5-.8 1.4-.3 2 0 0 .2.3.5.8 1.4 2.1 5.6 8.4 8.9 16.7h-42.9v-43.8c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v44.9c0 .1-.1.2-.1.3 0 .1 0 .2.1.3v9c-1.1 2-3.9 3.7-10.5 3.7h-7.5c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h7.5c5 0 8.5-.9 10.5-2.8-.1 3.1-1.5 6.5-10.5 6.5H210.4c-9 0-10.5-3.4-10.5-6.5 2 1.9 5.5 2.8 10.5 2.8h67.4c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-67.4c-6.7 0-9.4-1.7-10.5-3.7v-54.5c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v43.8h-43.6c4.2-10.2 9.4-17.4 9.5-17.5.5-.6.3-1.5-.3-2s-1.5-.3-2 .3c-.1.2-1.4 2-3.2 5 .1-4.9-.4-10.2-1.1-12.8zm221.4 60.2c-1.5 8.3-14.9 12-26.6 12H174.4c-11.8 0-25.1-3.8-26.6-12-1-5.7.6-19.3 4.6-30.2H197v9.8c0 6.4 4.5 9.7 13.4 9.7h105.4c8.9 0 13.4-3.3 13.4-9.7v-9.8h44c4 10.9 5.6 24.5 4.6 30.2z"></path><path d="M286.1 359.3c0 .4.3.7.7.7h14.7c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-14.7c-.3 0-.7.3-.7.7zm5.3-145.6c13.5-.5 24.7-2.3 33.5-5.3.4-.1.6-.5.4-.9-.1-.4-.5-.6-.9-.4-8.6 3-19.7 4.7-33 5.2-.4 0-.7.3-.7.7 0 .4.3.7.7.7zm-11.3.1c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7H242c-19.9 0-35.3-2.5-45.9-7.4-.4-.2-.8 0-.9.3-.2.4 0 .8.3.9 10.8 5 26.4 7.5 46.5 7.5h38.1zm-7.2 116.9c.4.1.9.1 1.4.1 1.7 0 3.4-.7 4.7-1.9 1.4-1.4 1.9-3.2 1.5-5-.2-.8-.9-1.2-1.7-1.1-.8.2-1.2.9-1.1 1.7.3 1.2-.4 2-.7 2.4-.9.9-2.2 1.3-3.4 1-.8-.2-1.5.3-1.7 1.1s.2 1.5 1 1.7z"></path><path d="M275.5 331.6c-.8 0-1.4.6-1.5 1.4 0 .8.6 1.4 1.4 1.5h.3c3.6 0 7-2.8 7.7-6.3.2-.8-.4-1.5-1.1-1.7-.8-.2-1.5.4-1.7 1.1-.4 2.3-2.8 4.2-5.1 4zm5.4 1.6c-.6.5-.6 1.4-.1 2 1.1 1.3 2.5 2.2 4.2 2.8.2.1.3.1.5.1.6 0 1.1-.3 1.3-.9.3-.7-.1-1.6-.8-1.8-1.2-.5-2.2-1.2-3-2.1-.6-.6-1.5-.6-2.1-.1zm-38.2 12.7c.5 0 .9 0 1.4-.1.8-.2 1.3-.9 1.1-1.7-.2-.8-.9-1.3-1.7-1.1-1.2.3-2.5-.1-3.4-1-.4-.4-1-1.2-.8-2.4.2-.8-.3-1.5-1.1-1.7-.8-.2-1.5.3-1.7 1.1-.4 1.8.1 3.7 1.5 5 1.2 1.2 2.9 1.9 4.7 1.9z"></path><path d="M241.2 349.6h.3c.8 0 1.4-.7 1.4-1.5s-.7-1.4-1.5-1.4c-2.3.1-4.6-1.7-5.1-4-.2-.8-.9-1.3-1.7-1.1-.8.2-1.3.9-1.1 1.7.7 3.5 4.1 6.3 7.7 6.3zm-9.7 3.6c.2 0 .3 0 .5-.1 1.6-.6 3-1.6 4.2-2.8.5-.6.5-1.5-.1-2s-1.5-.5-2 .1c-.8.9-1.8 1.6-3 2.1-.7.3-1.1 1.1-.8 1.8 0 .6.6.9 1.2.9z"></path></svg>';
//BG: The below function is used by both the Recently Viewed and Related Products. When looping through the products, we use the below as a template.
function outputProduct(data, outputLocation) {
    var imageRatioClass = $(outputLocation).attr('data-image-ratio');
    var productHTML = "";
        productHTML += '<div class="col-6 col-md-4 col-lg-3 featured-product">';
            productHTML += '<div class="product-image">';
                productHTML += '<a href="/products/'+data.handle+'" title="'+data.title+'" class="'+imageRatioClass+'">';
                    if (data.featured_image != null) {
                        productHTML += '<img data-sizes="auto" data-src="'+slate.Image.getSizedImageUrl(data.featured_image,'400x')+'" data-srcset="'+slate.Image.getSizedImageUrl(data.featured_image,'400x')+' 400w, '+slate.Image.getSizedImageUrl(data.featured_image,'540x')+' 540w, '+slate.Image.getSizedImageUrl(data.featured_image,'720x')+' 720w, '+slate.Image.getSizedImageUrl(data.featured_image,'900x')+' 900w" alt="'+data.title+'" class="img-fluid lazyload" />';
                    } else {
                        productHTML += svgPlaceholder;
                    }
                productHTML += '</a>';
                productHTML += '<span class="product-quickview"> <span class="btn btn-tertiary" data-product-url="/products/'+data.handle+'">Quick Buy</span></span>';
            productHTML += '</div>';
            productHTML += '<div class="product-details">';
                productHTML += '<a href="/products/'+data.handle+'" title="'+data.title+'">';
                    productHTML += '<h3 class="product-title">'+data.title+'</h3>';
                    productHTML += '<span class="product-price"><span class="money">'+slate.Currency.formatMoney(data.price, theme.moneyFormat)+'</span></span>';
                productHTML += '</a>';
            productHTML += '</div>';
        productHTML += '</div>';
  
    $(outputLocation).find('.row.featured-products-slick').append(productHTML);
}

/*
BG: persistentCheck: The idea being to constantly check (or persistently check) if the target exists, if it does, pass in an additional function that will trigger once condition is true. If condition is never true, have a timeoutTime to stop checking. 
*/
function persistentCheck(target,targetValue,paramFunction,paramTarget,timeoutTime) {
    //console.log('persistentCheckFunction');
    var checkExist = setInterval(function() {
        //console.log('Persistently checking for: '+target);
    //keep checking to see if condition is true 

    if ($(target).length > targetValue) {
            //console.log('condition is true, will no longer check.');
            //check paramFunction is actually a function
            if (typeof paramFunction == "function") {
                paramFunction(paramTarget); 
            }
            //clear interval
            clearInterval(checkExist);
        }
    }, 100); // check every 100ms
    
    setTimeout(function(){
        //console.log('couldn\'t find target or condition wasn\'t true');
        clearInterval(checkExist);
    }, timeoutTime);
}

//BG: JavaScript function of getting the URL Parameter
function getUrlParameter(parameter, url) {

    if (!url) {
        url = window.location.href;
    }

    parameter = parameter.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?|&]' + parameter.toLowerCase() + '=([^&#]*)');
    var results = regex.exec('?' + url.toLowerCase().split('?')[1]);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Templates ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        //$(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCart, this.$container).addClass('variant-available');
        $(selectors.addToCart, this.$container).removeClass('variant-not-available');
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        //$(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCart, this.$container).addClass('variant-not-available');
        $(selectors.addToCart, this.$container).removeClass('variant-available');
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
	});



//BG: Init slickSlider for Related Products.
function relatedSlickSlider(target) {
    $(target).slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 2,
        arrows:true,
        dots: false,
        prevArrow: slickPrevArrow,
        nextArrow: slickNextArrow,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
            },
            {
                breakpoint: 768,
                settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
            },
            {
                breakpoint: 480,
                settings: {
                slidesToShow: 1.5,
                infinite: false,
                slidesToScroll: 2,
                dots:false
            }
            }
        ]
    });
}


//BG: Make the call to the related products API
function relatedProductsAPI() {
var productID = $('.featured-products.related-products').attr('data-product-id');

    //Make the JSON request to the recommendations API, pass over the current product ID.
    $.getJSON('/recommendations/products.json?product_id='+productID+'&limit=8', function(data) {
        //for each product in the API Response, pass over to the output function.
        $.each(data.products,function(i, product) {
            //BG: outputProduct function used in settings/common.js. It's basic styling.
            outputProduct(product,'.featured-products.related-products');
            var increment = i + 1;

            //BG: if we've cycled through all products, trigger the slickInit
            if (data.products.length == increment) {
                //persistentCheck function in setting/common.js
                persistentCheck('.featured-products.related-products .featured-product',4,relatedSlickSlider,'.featured-products.related-products .featured-products-slick',5000);

                 //BG: Issue with QuickView not working after recentlyViewed products have been retrieved from array and outputted. Here we re-trigger the QuickView function defined in quick-view-collection.js
                persistentCheck('.featured-products.related-products .featured-product',0,quickViewNew,'none',5000);
            }
        });
    });
}
  
//Get URL Parameter
function getUrlParameter(name) {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	var results = regex.exec(location.search);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};


//BG: Intended to work with the 'back in stock' app. Trigger via button
function notifyApp() {
  var soldOutBtn = $('.btn-add-to-cart.variant-not-available'),
      notifyBtn = $('.BIS_trigger');

      soldOutBtn.click(function(e){
        e.preventDefault();  
        notifyBtn.click();
      });
}

//BG: Intended to work with the 'back in stock' app. Trigger via soldout size label
function notifyAppTwo() {
  var soldOutLabel = $('.soldout > label'),
      notifyBtn = $('.BIS_trigger');

      soldOutLabel.click(function(e){
        e.preventDefault();  
        notifyBtn.click();
      });
}

//BG: Intended to work with the 'back in stock' app. Trigger when all sizes are soldout
function notifyNoSizes() {
  if (!$('.swatch-element').hasClass('available')) {
    $('.BIS_trigger').click();
  }
}
	
  
  //Accordion Functionality.
function accordionToggle() {
	var accordionTitle = $('.accordion-title');
	
	$('.accordion-item.active .accordion-content').show();
	
	accordionTitle.click(function(){
		if ($(this).parent('.accordion-item').hasClass('active')) {
			$(this).parent('.accordion-item').removeClass('active');
			$(this).next('.accordion-content').slideUp();
		} else {
			
			$('.accordion-item').removeClass('active');
			$('.accordion-content').slideUp();
			
			$(this).parent('.accordion-item').addClass('active');
			$(this).next('.accordion-content').slideDown();
		}
	})
}

function sizeguideSelect() {
	var sizeTabs = $('.size-guide-frame .size-tabs li a'),
		sizeSelect = $('.size-guide-frame .size-tabs-select select'),
		sizeTable = $('.size-guide-frame table');

	$(sizeTabs).click(function(e){
		e.preventDefault();
		var tableOption = $(this).attr('data-option');

		$(sizeTable).removeClass('active');
		$(sizeTabs).parent('li').removeClass('active');

		$(sizeSelect).val(tableOption).change();

		$(this).parent('li').addClass('active');
		$('.size-guide-frame table[data-table="'+tableOption+'"]').addClass('active');
	});

	$(sizeSelect).on('change', function(){
		var tableOption = $(this).val();
		
		$(sizeTable).removeClass('active');
		$(sizeTabs).parent('li').removeClass('active');

		$('.size-guide-frame .size-tabs li a[data-option="'+tableOption+'"]').parent('li').addClass('active');

		$('.size-guide-frame table[data-table="'+tableOption+'"]').addClass('active');

	});
}

function sizeguideModal() {
    var closeIcon = $('.size-guide-frame .size-guide-close'),
		sizeguideOverlay = $('.size-guide-overlay'),
		sizeguideFrame = $('.size-guide-frame'),
		sizeguideOpen = $('.template-product .size-guide');

    $(closeIcon).click(function(){
        $(sizeguideFrame).removeClass('active');
        $(sizeguideOverlay).removeClass('active');
    })

    $(sizeguideOpen).click(function(){
        $(sizeguideFrame).addClass('active');
        $(sizeguideOverlay).addClass('active');
    })
}

//Checks to see if any colours are in the related_colours element, if there are then show the main colours div.
function colourChecker() {
  var productColoursContainer = document.querySelector('.product-related-colours');
  var productColours = document.querySelectorAll('.product-related-colours li');

  if (productColours.length > 0) {
    //Shows main container
    productColoursContainer.classList.add('active');
  }
}

function productSlick() {
    //Product Slick Slider Variables
    $mainImage = $('.product-detail-images-slick');
    mainSettings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        mobileFirst:true,
        prevArrow: slickPrevArrow,
        nextArrow: slickNextArrow,
        arrows: true
    }

    if ($(window).width() < screenLG) {
        $mainImage.slick(mainSettings);
    }

    // reslick only if it's not slick()
    $(window).on('resize', function() {
        if ($(window).width() > screenLG) {
            if ($mainImage.hasClass('slick-initialized')) {
                $mainImage.slick('unslick');
            }
        return
        }

        if (!$mainImage.hasClass('slick-initialized')) {
            return $mainImage.slick(mainSettings);
        }

    });
}

function whatsappIcon() {
    //if user on mobile, show whatsapp icon
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            $('.social-sharing-products .whatsapp').removeClass('d-none');
    } 
}

//BG: Product Image Zoom Options
function imageZoom() {
    $('.image-zoom').ezPlus({
        zoomType: 'lens',
        lensShape: 'round',
        lensSize: 300,
        zoomWindowFadeIn: 500,
        zoomWindowFadeOut: 500,
        lensFadeIn: 500,
        lensFadeOut: 500,
        //scrollZoom: true,
        //zoomWindowPosition: 1,
        borderColour: '#383e50'
    });
}

//BG: Open and close video display.
function productVideo() {
    var thumbnailPlay = $('.product-video-thumbnail'),
        videoEmbed = $('.video-overlay .rte__video-wrapper'),
        videoEmbedContent = $('.video-overlay .rte__video-wrapper').html(),
        videoClose = $('.video-close'),
        videoOverlay = $('.video-overlay'),
        videoBg = $('.background-overlay');

    thumbnailPlay.on('click',function() {
        videoOverlay.addClass('active');
        videoBg.addClass('active');
        videoEmbed.html(videoEmbedContent);
    });

    videoClose.on('click', function() {
        videoOverlay.removeClass('active');
        videoBg.removeClass('active');
        videoEmbed.html('');
    });

    videoOverlay.on('click', function() {
        $(this).removeClass('active');
        videoBg.removeClass('active');
        videoEmbed.html('');
    });

    videoBg.on('click', function () {
        $(this).removeClass('active');
        videoOverlay.removeClass('active');
        videoEmbed.html('');
    });
}

//BG: At desktop, it was agreed (between Chris & I) that we see the thumbnails swapping out the first main image with the selected thumbnail.
function swapProductImages() {
    var thumbnailImages = $('.product-image-thumbnail:not(.product-video-thumbnail)'),
        swapPlaceholder = $('.product-swap-placeholder').find('img:first-of-type');

    thumbnailImages.on('click', function(){
        //remove existing thumbnail if one exists.
        $('.thumbnail-stand-in').remove();

        var thumbnailOrder = $(this).attr('data-image-order'),
            thumbnailImageSmall = $(this).find('img').attr('data-zoom-small'),
            thumbnailImageZoom = $(this).find('img').attr('data-zoom-image'),
            thumbnailHTML = "<img src='"+thumbnailImageSmall+"' data-zoom-image='"+thumbnailImageZoom+"' class='img-fluid image-zoom thumbnail-stand-in'>";

            //console.log('thumbnail Order: ' + thumbnailOrder + ' ImageURL: ' + thumbnailImage);

        if (thumbnailOrder == 1) {
            swapPlaceholder.removeClass('d-none');
        } else {
            swapPlaceholder.addClass('d-none');
            swapPlaceholder.after(thumbnailHTML);
            imageZoom();
        }

    });
}

function productDescription() {
    var readmoreBtn = $('.product-description-show-more'),
    productDescription = $('.product-description.rte'),
    productDescriptionHeight = productDescription.height();

    readmoreBtn.off('click').on('click', function(e){
        if (readmoreBtn.hasClass('active')) {

            productDescription.removeClass('active');

            productDescription.animate({
                height: productDescriptionHeight
            }, 1000, function(){
                readmoreBtn.removeClass('active');
            });

            readmoreBtn.text('Show more');

        } else {

            productDescription.addClass('active');

            productDescription.animate({
                height: productDescription.get(0).scrollHeight
            }, 1000, function(){
                $(this).height('auto');
                readmoreBtn.addClass('active');
            });

            readmoreBtn.text('Show less');

        }

    });
}

//BG: Basic check to see if product Delivery times have been added via theme customiser, if they have, then show the accordion item.
function productDelivery() {
    var deliveryDetails = $('.accordion-item.delivery-item .product-delivery-row'),
        deliveryContainer = $('.accordion-item.delivery-item');

    if (deliveryDetails.length) {
        deliveryContainer.removeClass('d-none');
    }
}

//BG: Group together delivery details by their country.
function productDeliveryTitles() {
    var deliveryOptions = $('.product-delivery-row');

    deliveryOptions.each(function(){
        var countryName = $(this).attr('data-country-name');
        if (!$('.delivery-country[data-country-title="'+countryName+'"]').length) {
        $('.product-delivery-row[data-country-name="'+countryName+'"]').first().before('<h4 class="delivery-country" data-country-title="'+countryName+'">'+countryName+'</h4>');
        }
    });
}

//BG: On change, send the user to the colour product option they have selected.
function colourSelect() {
    $('select.product-colours.mobile').on('change', function () {
        var url = $(this).val(); 
        if (url) { 
            window.location = url; 
        }
        return false;
    });
}

//BG: Style the output from the Ajax request 
function outputColourSwatchProducts(json, currentProductID) {
    
    var listMarkup = '<ul class="product-colours desktop">',
        selectMarkup = '<select class="product-colours mobile">',
        productColourContainer = $('.product-colours-container');

    //for each product
    for (var key in json.products) {
        var productColour = json.products[key]['colour'],
            productURL = json.products[key]['url'],
            productID = json.products[key]['id'],
            activeClass = "",
            selected = "";

        //if current product ID matches the product ID in the loop, set active class and selected option.    
        if (productID === currentProductID) {
            activeClass = " current";
            selected = ' selected="selected"';
        }

        //Add option product to the list and select markup
        listMarkup += '<li><a href="'+productURL+'" class="'+productColour.toLowerCase()+''+activeClass+'">'+productColour+'</a></li>';
        selectMarkup += '<option value="'+productURL+'"'+selected+'>'+productColour+'</option>';

    }

    //close list and select markup
    listMarkup += '</ul>';
    selectMarkup += '</select>';

    //output the results.
    productColourContainer.append(listMarkup);
    productColourContainer.append(selectMarkup);
    productColourContainer.removeClass('d-none');

    colourSelect();

}

function getMatchingProductsByTag() {
    /* only run if this div exists. This won't appear if: 
    A) the snippet 'product-colour-swatch.liquid' file is not included on the product page 
    B) the product does not have a tag that contains "group_colours_"
    */
    if ($('.product-colours-container').length) {
        var colourGroupName = $('.product-colours-container').attr('data-colour-group'),
            currentProductID = $('.product-colours-container').attr('data-current-product-id'),
            currentCollection = $('.product-colours-container').attr('data-current-collection-handle');

            //Check to see if the current product is within a collection. if it's not default to 'all'
            //UPDATE: not all the colour variants sit within the same collection.
            //if (!currentCollection) {
                currentCollection = 'all'
            //}

        $.ajax({
            type: 'GET',
            //BG: "?view=colour" is a url parameter that will the template based on the value provided.
            // colourGroupName applies a Shopify filter that finds products based on product tag.
            url: '/collections/'+currentCollection+'/' + colourGroupName + '?view=colour',
            success: function (data) {
                if(data) {
                    try {
                        var json = JSON.parse(data);
                    } catch(e) {
                        var json = null; // meh
                    }
                }
                //if Json is sucessful, pass over to function to output the results.
                if (json) {
                    outputColourSwatchProducts(json,currentProductID);
                }
            }
        });
    }
}

function resizeMoveElements() {
    if ($(window).width() < screenMD) {
            productPromoMobile.before(productPromo);
        } else {
            productPromoDesktop.after(productPromo);
        };
}

//BG: re-arrange a couple of elements based on the designs.
function moveElements() {

    var productPromo = $('.product-promo'),
        productPromoMobile = $('.product-colour-row'),
        productPromoDesktop = $('.product-add-to-basket + .shopify-payment-button');

    if ($(window).width() < screenMD) {
        productPromoMobile.before(productPromo);
    } else {
        productPromoDesktop.after(productPromo);
    };

    $(window).on('resize', function() {
        if ($(window).width() < screenMD) {
            productPromoMobile.before(productPromo);
        } else {
            productPromoDesktop.after(productPromo);
        };
    });    
}

/*
BG: Update the mobileVariants (select field) with the variant ID.
    This function is triggered via changeProductByVariantID and ProductVariants
    It updates both the desktop, mobile and add to cart button with the users choice.
*/
function variantUpdate(variantID) {
    var desktopVariants = $('.product-variants-row ul.product-variants.desktop'),
    mobileVariants = $('.product-variants-row .product-variants.mobile'),
    btnAddToCart = $('.btn-add-to-cart'),
    variantIDValid = desktopVariants.find('li[data-variant-id="'+variantID+'"]');

    //Check to see if the variantID exists, if it does....
    if (variantIDValid.length) {

        var variantAvailability = desktopVariants.find('li[data-variant-id="'+variantID+'"]').attr('data-variant-available');

        //remove active class from all options, and only apply active class to li the user selected
        desktopVariants.find('li').removeClass('active');
        desktopVariants.find('li[data-variant-id="'+variantID+'"]').addClass('active');
        //remove selected attr from options and apply to option the user selected.
        mobileVariants.find('option:selected').prop('selected',false);
        mobileVariants.find('option[value="'+variantID+'"]').prop('selected', true);

        
        //update button state based on variant availability.
        var textAddToCart = btnAddToCart.attr('data-add-to-cart-text'),
            textSoldout = btnAddToCart.attr('data-sold-out-text');

        if (variantAvailability == 'true') {
            btnAddToCart.prop('disabled',false);
            btnAddToCart.removeClass('variant-not-available');
            btnAddToCart.addClass('variant-available');
            btnAddToCart.find('span').text(textAddToCart);
        } else {
            btnAddToCart.prop('disabled',true);
            btnAddToCart.removeClass('variant-available');
            btnAddToCart.addClass('variant-not-available');
            btnAddToCart.find('span').text(textSoldout);
        }

        //Update URL
        //Get the current URL without parameters
        var currentURLWithoutParams = window.location.href.split('?')[0];
        //update the page url with paramters
        history.pushState(null, null, currentURLWithoutParams+'?variant='+variantID);

    } else {
        console.log('variantID not valid, doesnt exist');
    }
}

//BG: if variant parameter is available in the URL, change the selection based on this.
function changeProductByVariantID() {
	var variantID = getUrlParameter('variant');

    if (variantID) {
		variantUpdate(variantID);
    }
}

/*
BG: Re-build the size variants, very heavy markup for what it is.
 */
function productVariants() {
    var desktopVariants = $('.product-variants-row ul.product-variants.desktop > li'),
        mobileVariants = $('.product-variants-row .product-variants.mobile');

    desktopVariants.on('click', function(){
        var variantID = $(this).attr('data-variant-id');
        variantUpdate(variantID);
    });

    mobileVariants.on('change',function(){
        var variantID = $(this).val();
        variantUpdate(variantID);
    })	
}
	
//BG: Only run on Product Page.
if ($('body.template-product').length) {

    productVariants()
    changeProductByVariantID();
  	accordionToggle();
  	//sizeguideSelect();
    //sizeguideModal();
    relatedProductsAPI();
    productSlick();
    whatsappIcon();
    imageZoom();
    swapProductImages();
    productVideo();
    productDescription();
    productDelivery();
    productDeliveryTitles();
    getMatchingProductsByTag();
    moveElements();
    
    
    //BG: App related functions for Product Page
    persistentCheck('.BIS_trigger',0,notifyApp,'nothing',10000);
    persistentCheck('.BIS_trigger',0,notifyAppTwo,'nothing',10000);

  }

  return Product;
})();


/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
	  
	if ($(this).hasClass('address-new-primary')) {
		$(this).addClass('hide');
	}
	  
	if ($(this).hasClass('address-new-secondary')) {
		$('.address-new-primary').removeClass('hide');
	}
	  
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
	  
	if ($(this).hasClass('address-edit-primary')) {
		$(this).addClass('hide');
	}
	  
	if ($(this).hasClass('address-edit-secondary')) {
		$('.address-edit-primary').removeClass('hide');
	}
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

function collectionReadMore() {
	var readmoreBtn = $('.collection-read-more'),
		collectionDescription = $('.collection-description .rte'),
		collectionDescriptionHeight = collectionDescription.height();

		readmoreBtn.off('click').on('click', function(e){

		if (readmoreBtn.hasClass('active')) {

			collectionDescription.removeClass('active');

			collectionDescription.animate({
				height: collectionDescriptionHeight
			}, 1000, function(){
				readmoreBtn.removeClass('active');
			});

			readmoreBtn.text('See More');

		} else {

			collectionDescription.addClass('active');

			collectionDescription.animate({
				height: collectionDescription.get(0).scrollHeight
			}, 1000, function(){
				$(this).height('auto');
				readmoreBtn.addClass('active');
			});

			readmoreBtn.text('See Less');

		}

	});
}

function filterToggle() {
	var filterTitle = $('.filter-title'),
		filterSidebar = $('.filter-sidebar');
	
	filterTitle.off('click').on('click', function(){
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			filterSidebar.slideUp();
		} else {
			$(this).addClass('active');
			filterSidebar.slideDown();
		}
	});
}

function collectionProductColourSwitcher() {
	var productColours = $('.collection-listing .product-colours li'),
		interactionType = "";

	if ($(window).width() <= screenMD) {
		interactionType = "click";
	} else {
		interactionType = "mouseover";
	}

	productColours.on(interactionType, function() {
		var productImage = $(this).attr('data-product-image'),
			productImageSecondary = $(this).attr('data-product-image-secondary'),
			productURL = $(this).attr('data-product-url'),
			productID = $(this).attr('data-product-id'),
			parentProductID = $(this).closest('#product_single').attr('data-product-id'),
			productColours = $(this).closest('#product_single').find('.product-colours li'),
			primaryImage = $(this).closest('#product_single').find('.product-image img'),
			parentProductURL = $(this).closest('#product_single').find('a'),
			quickView = $(this).closest('#product_single').find('.product-quickview span');

			productColours.removeClass('active');
			$(this).addClass('active');

			primaryImage.attr('src', productImage);
			primaryImage.attr('data-second-image', productImageSecondary);
			parentProductURL.attr('href', productURL);
			quickView.attr('data-product-url', productURL);
	});
}

//On the initial page load, set the sorting option to the first option.
function sortFilter() {
	if (getUrlParameter('sort')) {
		$( window ).one( "load", function() {
			$('#bc-sf-filter-top-sorting select option:first').attr("selected",true);
		});
	}
}

//BG: Changing the method of adding a second image. Rather than loading in the image as default, i'm loading in the URL to the second image, and will load it on hover.
function collectionProductHover() {
	$('.collection-listing .product-single .product-image.product-image-hover img').on("mouseenter", function(){
		var firstImage = $(this).attr('data-src'),
			secondImage = $(this).attr('data-second-image');
			
			$(this).attr('data-src',secondImage);
			$(this).attr('src',secondImage);
			$(this).attr('data-srcset',secondImage);
			$(this).attr('srcset',secondImage);
			$(this).attr('data-second-image',firstImage);
	});
	$('.collection-listing .product-single .product-image.product-image-hover img').on("mouseleave", function(){
		var secondImage = $(this).attr('data-src'),
			firstImage = $(this).attr('data-second-image');
			
			$(this).attr('data-src',firstImage);
			$(this).attr('src',firstImage);
			$(this).attr('data-srcset',firstImage);
			$(this).attr('srcset',firstImage);
			$(this).attr('data-second-image',secondImage);
	});
}

//BG: Collection toggle only appears on mobile, and it's defaulted listing view is two products per row.
function collectionView() {
    var savedCollectionView = localStorage.getItem('collectionView'),
        setCollectionView = $('#bc-sf-filter-products'),
        collectionToggle = $('.collection-view li');

    //BG: if collection view localstorage exists, lets set it.
    if (savedCollectionView == 'collection-view-one') {
        setCollectionView.removeClass('collection-view-two');
        setCollectionView.addClass(savedCollectionView);
        collectionToggle.removeClass('active');
        $('.collection-view li.view-one').addClass('active');
    }

    //on click
    collectionToggle.click(function(){
        collectionToggle.removeClass('active');

        //BG: if selecting two (which is default, simply delete the localstorage item)
        if ($(this).hasClass('view-two')) {
            localStorage.removeItem('collectionView');
            $(this).addClass('active');
            setCollectionView.removeClass('collection-view-one');
            setCollectionView.addClass('collection-view-two');
        //BG: if single, set localstage item
        } else {
            localStorage.setItem('collectionView','collection-view-one');
            $(this).addClass('active');
            setCollectionView.removeClass('collection-view-two');
            setCollectionView.addClass('collection-view-one');
        }
    });
}

//BG: just a simple addition of classes for mobile pagination. We only want to display, next,prev icons and the current pagination number, prev and next.
function paginationMobile() {
    var current = $('.pagination .current');
    current.prev().addClass('previous-page');
    current.next().addClass('next-page');
}

//BG: if the inline CTA is available, let's place it within the colleciton listings.
function inlineCTA() {
    if ($('.collection-inline-cta').length) {
        var ctaMarkup = $('.collection-inline-cta-container').html(),
            position = $('.collection-inline-cta').attr('data-cta-position'),
            collectionListing = $('#bc-sf-filter-products div.product-single:nth-child('+position+')');

        //BG:  only add the CTA if it hasn't been added already
        if ($('#bc-sf-filter-products .product-cta-inline').length <= 0) {
            collectionListing.after('<div class="product-single product-cta-inline">' + ctaMarkup + '</div>');
        }
    }
}

function scrollToTop() {
    $('.scroll-to-top').on('click', function(){
        $("html, body").animate({ scrollTop: 0 }, 1500);
    });
}

//BG: if fixed ratio has been defined, apply it to the product listing anchor.
function fixedRatio() {
    var collectionFixedRatio = $('#bc-sf-filter-products').attr('data-fixed-ratio');

    if ($('#bc-sf-filter-products').length > 0) {
        if (collectionFixedRatio) {
            $('#bc-sf-filter-products .product-single .product-image > a').addClass(collectionFixedRatio);
        }
    }
}

//BG: if product label is set via theme customiser, override the individual product labels.
function categoryProductLabelOverride() {

    if ($('.category-product-label')) {

        var htmlMarkup = $('.category-product-label').html();

        $('#bc-sf-filter-products #product_single .product-image').append(htmlMarkup);
    }
}

//BG: Check if a Product Label and Variant exists on a product listing, if it does, apply a class.
function categoryLabelAndVariants() {
    var products = $('#bc-sf-filter-products #product_single');

    products.each(function(){
        var productVariants = $(this).find('.product-variants'),
            productLabel = $(this).find('.product-label');

        if (productVariants.length > 0 && productLabel.length > 0) {
            $(this).addClass('has-variants-and-label');
        }    
    });

}

collectionReadMore();
filterToggle();
collectionProductHover();
collectionView();
paginationMobile();
//inlineCTA();
scrollToTop();
fixedRatio();
//Update the quantity field on the cart page. Based on plus and minus buttons.
function cartQuantity() {
	var cartQuantity = $('.cart-product-quantity');

	
	cartQuantity.each(function(){
		var quantityUp = $(this).find('.quantity-up'),
			quantityDown = $(this).find('.quantity-down'),
			quantityValue = $(this).find('.cart-item__qty');
		
		
		quantityUp.on('click',function(){

			var currentVal = parseInt(quantityValue.val());
			if (!isNaN(currentVal)) {
				quantityValue.val(currentVal + 1);
			}
			$('.btn-cart-update').click();
		});
		quantityDown.on('click',function(){
			var currentVal = parseInt(quantityValue.val());
			if (!isNaN(currentVal) && currentVal > 1) {
				quantityValue.val(currentVal - 1);
			}
			$('.btn-cart-update').click();
		});
		
		quantityValue.bind('input',function() {
			$('.btn-cart-update').click();
		});
	});

}


function cartQuantitySelect() {
	var cartQuantity = $('.product-quantity');

	cartQuantity.each(function(){
		var quantitySelect = $(this).find('.product-quantity-select'),
			quantityValue = $(this).find('.product-quantity-value').attr('value'),
			quantityInput = $(this).find('.product-quantity-value');

		//On initial load, set the dropdown to reflect the current quantity.	
		quantitySelect.find('[value="'+quantityValue+'"]').attr('selected', true);

		// LM Once quantity has been changed, need to update input value beneath so checkout quanity is updated as well.
		quantitySelect.on('change', function(){
			var selectedValue = $(this).find(':selected').attr('value');
			var selectedInput = $(this).next();

			$(selectedInput).attr('value', selectedValue);
		});
	});
}


//BG: Check if user has entered a value, and inform the user it's been applied and will confirm if it works on checkout.
function promoCode() {
    var discountFormInputValue = $('.discount-form input[type="text"]').val(),
    promoFeedback = $('.discount-form .promo-feedback');

    if (discountFormInputValue) {
        promoFeedback.removeClass('d-none');
        promoFeedback.slideDown();
        promoFeedback.html('<strong>' + discountFormInputValue + '</strong> has been applied, checkout page will confirm if code is valid');
    }
}

//BG: Capture promo code, and confirm to user.
function capturePromoCode() {
    var discountFormInput = $('.discount-form input[type="text"]'),
        discountFormBtn = $('.discount-form .btn');

    discountFormInput.on('keydown', function(e){
        if (e.keyCode == 13) {
            e.preventDefault();
        }
    });

    discountFormInput.on('keyup', function (e) {
        if (e.keyCode == 13) {
            e.preventDefault();
            promoCode();
        }
    });

    discountFormBtn.on('click', function(e) {
        e.preventDefault();
        promoCode();
    });
}

//cartQuantity();
cartQuantitySelect();
capturePromoCode();
function forgotPassword() {

	var loginForm = $('#CustomerLoginForm'),
		passwordForm = $('#RecoverPasswordForm');

	$('.show-forgot-password').click(function(){
		loginForm.addClass('hide');
		passwordForm.removeClass('hide');
	});

	$('.hide-forgot-password').click(function(){
		loginForm.removeClass('hide');
		passwordForm.addClass('hide');
	});
}

function resetPasswordForm() {
	var formState = $('.reset-password-success')

	if (formState.length) {
		$('#ResetSuccess').removeClass('hide');
	}
}


//BG: Tokyo Laundry want to capture Birthdays.
function birthdayFormat(form) {
    var birthdayField = form.find('#Birthday'),
        birthdayFieldValue = 'Day/Month/Year',
        birthdayDay = form.find('#birthday-day'),
        birthdayDayValue = '',
        birthdayMonth = form.find('#birthday-month'),
        birthdayMonthValue = '',
        birthdayYear = form.find('#birthday-year'),
        birthdayYearValue = '';
    
    function combinedValue() {
        birthdayFieldValue = birthdayDayValue +' '+birthdayMonthValue +' '+ birthdayYearValue;
        birthdayField.val(birthdayFieldValue);
    }    

    birthdayDay.on('change', function(){
        birthdayDayValue = $(this).val();
        combinedValue();
    });

    birthdayMonth.on('change', function(){
        birthdayMonthValue = $(this).val();
        combinedValue();
    });

    birthdayYear.on('change', function(){
        birthdayYearValue = $(this).val();
        combinedValue();
    });
}

//BG: Check to see if the form is valid.
function checkFormValidation(form) {
    var invalidFields = form.find('label.required'),
        invalidFieldsCount = 0,
        validFieldsCount = 0;

    invalidFields.each(function(){
        if ($(this).hasClass('validated')) {
            validFieldsCount++;
        } else {
            invalidFieldsCount++;
        }
    });
    if (invalidFieldsCount === 0) {
        form.removeClass('validation-invalid');
    }

    //console.log('invalid count:'+invalidFieldsCount);
    //console.log('valid count:' +validFieldsCount);
}

//BG: build error message, what the message contains and where it should output.
function feedbackMessage(field, status, message,form) {
    var messageNoWhitespace = field.replace(/\s/g, ""),
        html = "<div class='ajaxfeedback "+status+" "+messageNoWhitespace+"'>"+message+"</div>";

    //if error messages are already showing, don't show again.
    if ($('.ajaxfeedback.' + messageNoWhitespace).length == 0) {
        form.before(html);
    }
}

function confirmPasswords(form) {
    $('#CreatePassword').on('input', function(){
        var passwordOneValue = $('#PasswordOne').val(),
            passwordTwoValue = $('#CreatePassword').val();

        if (passwordOneValue != passwordTwoValue) {
            $('.ajaxfeedback.Password').remove();
            feedbackMessage('Password','error','Passwords do not match',form);
            $('label.password-required').removeClass('validated');
        } else {
            $('.ajaxfeedback.Password').remove();
            $('label.password-required').addClass('validated');
            feedbackMessage('Password','success','Passwords match',form);
            checkFormValidation(form);
        }
    });  
}


//BG: Check input values
function checkRequiredFields(form) {
    var formFields = form.find('input.required:not(.password-required)'),
        passwordFields = form.find('input.password-required');

    //For each required field....
    formFields.each(function(){
        //on input should detect: paste, right click, deleting text or typing text. 
        $(this).on('input', function(){
            var thisValue = $(this).val(),
                label = $(this).attr('id'),
                labelNoWhitespace = label.replace(/\s/g, "");

            //If the value is greater than 0
            //add valid input classes and remove invalid messages
            if (thisValue.length > 0) {
                $(this).addClass('input-valid');
                $(this).removeClass('input-invalid');
                $('label[for="' + labelNoWhitespace + '"]').addClass('validated')
                $('.ajaxfeedback.'+labelNoWhitespace).remove();
                checkFormValidation(form);
            } else {
                $(this).removeClass('input-valid');
                $(this).addClass('input-invalid');
                $('label[for="' + labelNoWhitespace + '"]').removeClass('validated')
            }
        });
    });

    if (passwordFields.length > 0) {
        confirmPasswords(form);
    }
}

//Highlighted the required fields to the user, and output error message.
function highlightRequiredFields(form) {
    //get list of labels
    var invalidFormLabels = form.find('label.required:not(.validated)'),
        once = 0;

    invalidFormLabels.each(function(){
        if ($(this).hasClass('password-required')) {
            //Run once
            if (once == 0) {
                feedbackMessage('Password','error','<strong>Password</strong> this field is required.',form);
                once++;
            }
        } else {
            var labelValue = $.trim($(this).text());
            feedbackMessage(labelValue,'error','<strong>'+labelValue+'</strong> this field is required.',form)
        }
    })

}

/* 
BG: Basic form validation intended for the registration form.
*/
function registrationFormValidation() {
    var registrationForm = $('#create_customer');

    checkRequiredFields(registrationForm);
    birthdayFormat(registrationForm);

    registrationForm.on('submit', function(e) {
        //If class is present, don't submit form.
        if ($(this).hasClass('validation-invalid')) {
            e.preventDefault();
            highlightRequiredFields(registrationForm);
        } 
    });
}

function addressEditDelete() {

    //Delete Address, confirm user action.    
    $('.address-delete').on('click', function() {
        var $el = $(this);
        var formId = $el.data('form-id');
        var confirmMessage = $el.data('confirm-message');
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
        }
    });
    
    //Toggle edit address
    $('.edit-address').on('click', function() {
        var formId = $(this).attr('data-form-id');
        $('#EditAddress_' + formId).toggleClass('hide');
          
        if ($(this).hasClass('address-edit-primary')) {
            $(this).addClass('hide');
        }
          
        if ($(this).hasClass('address-edit-secondary')) {
            $('.address-edit-primary').removeClass('hide');
        }
    });
}

function accountNavigation() {
    var accountSidebarTitle = $('.account-sidebar h3'),
        accountSidebarNavigation = $('.account-sidebar-navigation');

   accountSidebarTitle.on('click', function(){
        accountSidebarTitle.toggleClass('active');
        accountSidebarNavigation.toggleClass('active');
   });   
}

addressEditDelete();
resetPasswordForm();
forgotPassword();
registrationFormValidation();
accountNavigation();
function sidebarLinks() {
	var sidebarTitle = $('.sidebar-title'),
		sidebarContent = $('.sidebar-content');

	if ($(window).width() <= screenMD) {
		
		sidebarTitle.off('click').on('click', function(){
			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				$(this).next('.sidebar-content').slideUp();
			} else {
				$(this).addClass('active');
				$(this).next('.sidebar-content').slideDown();
			}
		});
		
	} else {
		sidebarTitle.off('click');
		sidebarContent.css('display', '');
	}
}

//BG: This function works with child links in the side navigation. 
function sidebarNavigation() {
    var parentLink = $('.sidebar-navigation .parent');

    $('.sidebar-navigation .child-menu .active').parents('.parent').addClass('active');
    $('.sidebar-navigation .child-menu .active').parents('.parent').find('.child-menu').slideDown();

    parentLink.on('click', function(){
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).find('.child-menu').slideUp();
        } else {
            parentLink.removeClass('active');
            parentLink.find('child-menu').slideUp();
            $(this).addClass('active');
            $(this).find('.child-menu').slideDown();
        }
    });

}

//Accordion Functionality.
function accordionToggle() {
	var accordionTitle = $('.accordion-title');
	$('.accordion-item.active .accordion-content').show();
	
	accordionTitle.click(function(){
		if ($(this).parent('.accordion-item').hasClass('active')) {

			$(this).parent('.accordion-item').removeClass('active');
            $(this).next('.accordion-content').slideUp();
            
		} else {
			
			$(this).parents('.accordion-container').find('.accordion-item').removeClass('active');
			$(this).parents('.accordion-container').find('.accordion-content').slideUp();
			
			$(this).parent('.accordion-item').addClass('active');
			$(this).next('.accordion-content').slideDown();
		}
	})
}

//sidebarLinks();
sidebarNavigation();

if (!$('body.template-product').length) {
    accordionToggle();
}

$(window).on('resize',function() {
    sidebarLinks();
});
function categoryToggle() {
	var categoryTitle = $('.categories-title'),
		categorySidebar = $('.categories-links');
	
	if ($(window).width() <= screenLG) {
		
		categoryTitle.off('click').on('click', function(){
			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				categorySidebar.slideUp();
			} else {
				$(this).addClass('active');
				categorySidebar.slideDown();
			}
		});
		
	} else {
		categoryTitle.off('click');
		categorySidebar.css('display', '');
	}
}

function returnToBlog() {
	var blogTags = $('.blog-tags li a');

	if ($(blogTags).hasClass('active')) {
		$('.return-to-blog').removeClass('d-none');
	}
}

//categoryToggle();
returnToBlog();

$(window).on('resize',function() {
    //categoryToggle();
});

/*================ Sections ================*/
// Used with sections/header-text-features.liquid
function textFeaturesSlick() {	
	$slick_slider = $('.text-features-slick');
	slicksettings = {
		slidesToShow: 3,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		prevArrow: slickPrevArrow,
		nextArrow: slickNextArrow,
		responsive: [
		  {
			breakpoint: 768,
			settings: {
			  slidesToShow: 2
			}
		  },
		  {
			breakpoint: 576,
			settings: {
			  slidesToShow: 1
			}
		  }
		]
	}
	  
	if ($(window).width() < screenLG) {
		$slick_slider.slick(slicksettings);
	}
  
	// reslick only if it's not slick()
	$(window).on('resize', function() {
	   if ($(window).width() > screenLG) {
	 	if ($slick_slider.hasClass('slick-initialized')) {
	 	  $slick_slider.slick('unslick');
	 	}
	 	return
	   } else {
	 	  if (!$slick_slider.hasClass('slick-initialized')) {
	 		return $slick_slider.slick(slicksettings);
	 	  }
	   }
	});
}

$(document).ready(function() {	
    //textFeaturesSlick();
});
//Open and close the mobile Search
function siteSearch() {
	var searchIcon = $('#site-header .header-search-icon'),
		searchBar = $('.search-bar');

	searchIcon.click(function(){
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			searchBar.slideUp();
		} else {
			$(this).addClass('active');
			searchBar.slideDown();
			searchBar.find('input').focus();
		}
	});
}

//Toggle open and close of mobile navigation
function mobileNavigationMenuToggle() {
	var menuIcon = $('#site-header .header-mobile-menu'),
		menu = $('#site-navigation'),
		overlay = $('.nav-overlay');

	menuIcon.click(function(){
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			menu.removeClass('active');
			overlay.removeClass('active');
			$('html').removeClass('nav-open');
			$('body').removeClass('nav-push');

		} else {
			$(this).addClass('active');
			menu.addClass('active');
			overlay.addClass('active');
			$('html').addClass('nav-open');
			$('body').addClass('nav-push');
		}
	});

	overlay.click(function() {
		$(this).removeClass('active');
		menu.removeClass('active');
		menuIcon.removeClass('active');
		$('body').removeClass('nav-push');
		$('html').removeClass('nav-open');
	})
}

//Toggle open and close of the individual links within the navigation.
function mobileNavigation() {
    var parentLink = $('#site-navigation .has-child > a'),
        parentBackLink = $('.mobile-menu-actions .menu-back'),
        parentNextLink = $('.mobile-menu-actions .menu-next'),
		secondaryLink = $('#site-navigation .sub-menu-title'),
		tabLinks = $('#site-navigation .mobile-navigation-tabs ul li a'),
		primaryNavigation = $('#site-navigation .top-level'),
		secondaryNavigation = $('#site-navigation .account-navigation-links'),
		subparentLink = $('#site-navigation .has-children > a');
	
	if ($(window).width() <= screenLG) {
		//console.log('screenSM and Lower');
		
		//unbind and bind click action - can cause issues when resizing browser
		parentLink.off('click').on('click', function(e) {
			//print anchor from working.
			e.preventDefault();
			
			//add active class to parent and slide down child menus.
			if ($(this).parent('li').hasClass('active')) {
                $(this).parent('li').removeClass('active');	
				$(this).next('.sub-menu-container').removeClass('open');
			} else {
				parentLink.parent('li').removeClass('active');
                parentLink.next('.sub-menu-container').removeClass('open');
                $(this).parent('li').addClass('active');
				$(this).next('.sub-menu-container').addClass('open');
            }
            
            //Get the 'next' parent link for submenu. If we can't find the next link, try to find a previous link.
            var checkNextLink = $(this).parent('li').next('li.has-child').children('a').text();
            if (checkNextLink) {
                var nextLink = checkNextLink;
            } else {
                var nextLink = $(this).parent('li').prev('li.has-child').children('a').text();
            }
            $(this).next('.sub-menu-container').find('.menu-next .text').text(nextLink);


        });
        
        //return the user to the main menu
        parentBackLink.off('click').on('click', function(e) {
            $(this).parents('li.active').find('.sub-menu-container').removeClass('open');
            $(this).parents('li.active').removeClass('active');
        });

        //close the current sub menu and open the 'next' submenu.
        parentNextLink.off('click').on('click',function(e){
            var nextText = $(this).find('.text').text().replace(/\s/g,'').toLowerCase();
            $(this).parents('li.active').find('.sub-menu-container').removeClass('open');
            $(this).parents('li.active').removeClass('active');

            setTimeout(function(){
                $('.menu-item-'+nextText).children('a').click();
            }, 600); 
        });

		//unbind and bind click action - can cause issues when resizing browser
		subparentLink.off('click').on('click', function(e) {
			//print anchor from working.
			e.preventDefault();
			
			//add active class to parent and slide down child menus.
			if ($(this).parent('li').hasClass('active')) {
				$(this).next('.grandchild-menu').slideUp(400, function(){
					$(this).parent('li').removeClass('active');	
				});
			} else {
				subparentLink.parent('li').removeClass('active');
				subparentLink.next('.grandchild-menu').slideUp();
				$(this).next('.grandchild-menu').slideDown(400, function() {
					$(this).parent('li').addClass('active');
				});
			}
		});

		secondaryLink.off('click').on('click', function(e) {
			var link = $(this);
			if ($(this).hasClass('active')) {
				$(this).next('ul').slideUp(400, function(){
					link.removeClass('active');
				});
			} else {
				secondaryLink.removeClass('active').next('ul').slideUp();
				$(this).next('ul').slideDown(400, function(){
					link.addClass('active');
				});
			}
		});

		tabLinks.off('click').on('click', function(e){
			e.preventDefault();

			var hash = $(this).attr('href');
			
			if (hash == "#account") {
				primaryNavigation.addClass('d-none');
				secondaryNavigation.removeClass('d-none');
				$('#site-navigation .mobile-navigation-tabs ul li').removeClass('active');
				$(this).parent().addClass('active');
			} else {
				primaryNavigation.removeClass('d-none');
				secondaryNavigation.addClass('d-none');
				$('#site-navigation .mobile-navigation-tabs ul li').removeClass('active');
				$(this).parent().addClass('active');
			}

		});

		$('#site-navigation').addClass('transition');
		
	} else {
		parentLink.off('click');
		parentLink.next('.sub-menu').css('display', '');
		secondaryLink.off('click');
		secondaryLink.next('ul').css('display','');
		secondaryNavigation.addClass('d-none');
		primaryNavigation.removeClass('d-none');
		$('#site-navigation .mobile-navigation-tabs ul li').removeClass('active');
		$('#site-navigation .mobile-navigation-tabs ul li:first-of-type').addClass('active');
		
		$('#site-navigation').removeClass('active transition');
		$('.nav-overlay').removeClass('active');
		$('.header-mobile-menu').removeClass('active');
		$('body').removeClass('nav-push');
		//console.log('greater than screenSM');
		
	}
}

function desktopNavigation() {
	var mainNavigation = $('#site-navigation'),
		navOverlay = $('.nav-overlay'),
		parentLink = $('#site-navigation .has-child');
	
	if ($(window).width() >= screenLG) {
		//console.log('Screen LG & Greater');
		
		parentLink.on("mouseover", function() {
			$(this).addClass('active');  
			$(this).find('.menu').addClass('active');
			navOverlay.addClass('active');

			//UPDATE
			//BG: for performance reasons, we are now going to load the images within the mega menu when the user hovers on the menu.

			var navigationImages = $(this).find('.sub-menu-image img');
			navigationImages.each(function(){
				var imageURL = $(this).attr('data-image-url')
				if (imageURL) {
					$(this).attr('src',imageURL);
					$(this).removeClass('img-full');
				}
			});
		

		});
		
		parentLink.on("mouseout", function() {
			$(this).removeClass('active');  
			$(this).find('.menu').removeClass('active');
			navOverlay.removeClass('active');
		});

		
		
	} else {
		//console.log('Lower than Screen LG');
		mainNavigation.off("mouseover");
		mainNavigation.off("mouseout");
		parentLink.off("mouseover");
		parentLink.off("mouseout");
	}
}

//BG: Need to move the navigation when on mobile so it doesn't clash with the fixed header.
function moveNavigation() {

	var navigationContainer = $('.site-navigation-container'),
		bodyContainer = $('.body-container'),
		navOverlay = $('.nav-overlay'),
		navigation = $('#site-navigation');


	if ($(window).width() <= screenMD) {
		
		navigation.insertBefore(bodyContainer);
		navOverlay.insertBefore(bodyContainer);

	} else {
		navigationContainer.append(navigation);
		navOverlay.insertAfter('#MainContent');
	}
}

//BG: Because the header is fixed, we need to add padding to ensure nothing is hidden behind the header.
function headSpaceFix() {
	var header = $('#site-header');

	var headerHeight = header.outerHeight(true);
	
	$('body').css('padding-top',headerHeight);
}

function headroom() {
	// grab an element
	var header = document.querySelector("header");
	// construct an instance of Headroom, passing the element
	var headroomHeader  = new Headroom(header, {
		"offset": 150
	});
	// initialise
	headroomHeader.init(); 
}

function countrySelect() {
	var currentCountry = $('.current-country li');

	currentCountry.click(function(){
		$(this).toggleClass('active');
	});
}

function cartShow() {
	var cartLink = $('.header-basket > a');

	if ($(window).width() >= screenLG) {
		cartLink.off('click').on('click', function(event){
			if ($(this).hasClass('active')) {
				event.preventDefault();
				$(this).removeClass('active');
				$('.cart-mini-contents').removeClass('active');
				$('.nav-overlay').removeClass('active');
				$('body').removeClass('no-scroll');
			} else {
				event.preventDefault();
				$(this).addClass('active');
				$('.cart-mini-contents').addClass('active');
				$('.nav-overlay').addClass('active');
				$('body').addClass('no-scroll');
			}
		});
	}

	$('.cart-mini-contents .icon-close').on('click', function(){
		cartLink.removeClass('active');
		$('.cart-mini-contents').removeClass('active');
		$('.nav-overlay').removeClass('active');
		$('body').removeClass('no-scroll');
	});

	$('.nav-overlay').click(function() {
		$(this).removeClass('active');
		cartLink.removeClass('active');
		$('.cart-mini-contents').removeClass('active');
		$('body').removeClass('no-scroll');
	})
}

//BG: Check the header action link to see if it contains a '#' if it does, assume the client wants the user to scroll to an element on the page. 
function headerActionLink() {
    var headerActionLink = $('.header-actions .header-action-link a'),
        headerActionValue = $('.header-actions .header-action-link a').attr('href');

    //if '#' exists....
    if (headerActionValue.indexOf('#') > -1 ) {
        headerActionLink.on('click', function(e){
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $(headerActionValue).offset().top
            }, 2000);
        });
    } 
}

//BG: init for sticky.js
//Documentation https://github.com/rgalus/sticky-js#available-options
function stickyJS() {
    setTimeout(function(){
        var sticky = new Sticky('[data-sticky]');
    }, 500); 
}

/*
BG: This is only needed when the sale banner isn't visible, the stickyJS doesn't seem to work as intended when it's the first item that needs sticking.
 */
function headerTopSpacer() {
    const headerSaleBanner = document.querySelector('.header-sale-banner');

    if (!$('.header-sale-banner').length > 0) {

        if ($(window).width() >= screenMD) {

        var headerTop = $('.header-top'),
            siteHeader = $('#site-header'),
            headerTopheight = headerTop.outerHeight(true);

            siteHeader.css('margin-top',headerTopheight);

        } else {
            $('#site-header').removeAttr('style');
        }

    }
 }

$(document).ready(function() {	
    siteSearch();
    mobileNavigationMenuToggle();
    mobileNavigation()
	desktopNavigation();
	//headroom();
	//headSpaceFix();
	moveNavigation();
	countrySelect();
    cartShow();
    stickyJS();
    headerActionLink();
    headerTopSpacer();
});

$(window).on('resize',function() {
    mobileNavigation();
	desktopNavigation();
	//headSpaceFix();
    moveNavigation();
    headerTopSpacer();
});
function footerLinks() {
	var footerTitle = $('footer .footer-title:not(.nocollapse)'),
		footerContent = $('footer .footer-content');

	if ($(window).width() <= screenSM) {
		
		footerTitle.off('click').on('click', function(){
			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				$(this).next('.footer-content').slideUp();
			} else {
				$(this).addClass('active');
				$(this).next('.footer-content').slideDown();
			}
		});
		
	} else {
		footerTitle.off('click');
		footerContent.css('display', '');
	}
}

function aboutusReadMore() {
	var readmoreBtn = $('section.about-us span.read-more'),
		contentDescription = $('section.about-us .rte'),
		contentDescriptionHeight = contentDescription.height();

		readmoreBtn.off('click').on('click', function(e){
		if (readmoreBtn.hasClass('active')) {

			contentDescription.removeClass('active');

			contentDescription.animate({
				height: contentDescriptionHeight
			}, 1000, function(){
				readmoreBtn.removeClass('active');
			});

			readmoreBtn.text('Read More');

		} else {

			contentDescription.addClass('active');

			contentDescription.animate({
				height: contentDescription.get(0).scrollHeight
			}, 1000, function(){
				$(this).height('auto');
				readmoreBtn.addClass('active');
			});

			readmoreBtn.text('Read Less');

		}

	});
}


footerLinks();
aboutusReadMore();

$(window).on('resize',function() {
    footerLinks();
});
// Used with sections/header-text-features.liquid
function headerTopFeaturesSlick() {	
	$slick_slider = $('.header-top-slick');
	slicksettings = {
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		arrows: false,
		dots: false,
		autoplay: true,
		autoplaySpeed: 10000
	}

    $slick_slider.slick(slicksettings);
}

$(document).ready(function() {
    setTimeout(function(){  
        headerTopFeaturesSlick();
    }, 500);
});
// Used with sections/mobile-collection-scroll.liquid
function mobileCollectionSlick() {	
	$slick_slider_mobile = $('.mobile-collection-slick');
	slicksettingsMobile = {
		slidesToShow: 4.5,
		slidesToScroll: 1,
		infinite: false,
		arrows: false,
		dots: false,
		autoplay: false,
		draggable: true
	}

	$slick_slider_mobile.slick(slicksettingsMobile);
}

$(document).ready(function() {	
    mobileCollectionSlick();
});
// Used with sections/mobile-collection-scroll.liquid
function homepageFeaturedCollection() {	
	$slick_slider = $('.homepage-featured-collection-slick');
	slicksettings = {
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: false,
		arrows: false,
		dots: false,
		autoplay: false,
		draggable: true
	}

	if ($(window).width() < screenMD) {
		$slick_slider.slick(slicksettings);
	}
  
	// reslick only if it's not slick()
	$(window).on('resize', function() {
	   if ($(window).width() > screenMD) {
	 	if ($slick_slider.hasClass('slick-initialized')) {
	 	  $slick_slider.slick('unslick');
	 	}
	 	return
	   } else {
	 	  if (!$slick_slider.hasClass('slick-initialized')) {
	 		return $slick_slider.slick(slicksettings);
	 	  }
	   }
	});
}

$(document).ready(function() {
	homepageFeaturedCollection();
});


/*================ Snippets ================*/
function heroSlickInit() {
    $('.hero-slick').each(function(){
        var heroSlick = $(this);
        $(heroSlick).slick({
                prevArrow: slickPrevArrow,
                nextArrow: slickNextArrow
        });
    });
}

heroSlickInit();
function featuredProductsSlick() {
    $('section.featured-products.homepage-featured .featured-products-slick').each(function(){
		$(this).slick({
			lazyLoad: 'ondemand',
			prevArrow: slickPrevArrow,
			nextArrow: slickNextArrow
		});
	});
}

featuredProductsSlick();
function featuredImagesSlick() {
    $('.featured-images-slider-slick').slick({
		prevArrow: slickPrevArrow,
		nextArrow: slickNextArrow
	});

	var stHeight = $('.featured-images-slider-slick .slick-track').height();
	$('.featured-images-slider-slick .slick-slide').css('height',stHeight + 'px' );
}

featuredImagesSlick();
//BG: Init slickSlider for Recently Viewed and Related Products.
function recentSlickSlider(target) {
    $(target).slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 2,
        arrows:true,
        dots: false,
        prevArrow: slickPrevArrow,
        nextArrow: slickNextArrow,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
            },
            {
                breakpoint: 768,
                settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
            },
            {
                breakpoint: 480,
                settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots:false
            }
            }
        ]
    });
}

function homepageRecentSlickSlider(target) {
    $(target).slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 2,
        arrows:true,
        dots: false,
        prevArrow: slickPrevArrow,
        nextArrow: slickNextArrow,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
            },
            {
                breakpoint: 768,
                settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
            },
            {
                breakpoint: 480,
                settings: {
                infinite: false,
                slidesToShow: 1.5,
                slidesToScroll: 1,
                dots:false
            }
            }
        ]
    });
}

function quickViewTrigger() {
    quickView();
}

//BG: Grab the recently viewed products array, and loop through the products and output them.
function retrieveRecentlyViewedProducts(array,outputLocation,maxProducts) {

    //if the array is greater than max allowed products, delete the last product from the array.
    if (array.length > maxProducts) {
        array.shift();
    }

    //if there are products to display, remove the hidden class.
    if (array.length > 0) {
        $(outputLocation).removeClass('d-none');
    }
    // loop for the array, and output the products.
    $.each(array,function(i, product) {
        //ensure the product isn't undefined.
        if (product != "undefined.js" && product != ".js") {
            //make a json request based on the product handle.
            var ajax = $.getJSON('/products/' + product, function(data) {
                //pass the data over to the below function
                outputProduct(data,outputLocation);
            }).fail(function() { 
                //BG: This should rarely happen, but if the product is no longer available, we get a json error, so want to remove the product from the array. 
                console.log('product not found, but it will be removed from array on next page load')
                var arrayFix = array.indexOf(product);
                if (arrayFix !== -1) {
                     array.splice(arrayFix,1);
                }
                //BG: Update localStorage
                localStorage.setItem("recentProducts", JSON.stringify(arrayFix));
            });
        }

        //Check to see if it's the last item in the Array, if it is...
        var increment = i + 1;

        if (array.length == increment) {
            if ($('body.template-index').length) {
                persistentCheck('.featured-products.product-recently-viewed .featured-product',4,homepageRecentSlickSlider,'.featured-products.product-recently-viewed .featured-products-slick',5000);
            } else {
                setTimeout(function(){
                    persistentCheck('.featured-products.product-recently-viewed .featured-product',4,recentSlickSlider,'.featured-products.product-recently-viewed .featured-products-slick',5000);
                }, 1000); 
            }

            //BG: Issue with QuickView not working after recentlyViewed products have been retrieved from array and outputted. Here we re-trigger the QuickView function defined in quick-view-collection.js
            persistentCheck('.featured-products.product-recently-viewed .featured-product',0,quickViewNew,'none',5000);
        }
	});
}

//BG: Add current product to the recently viewed array
function addNewProduct(array,productHandle,maxProducts) {

  //BG: if array is greater than the maxProducts, then delete the first item in the array
  if (array.length > maxProducts) {
    array.shift();
  }

  //BG: only add the product to the array, if it doesn't already exist
  if(array.indexOf(productHandle) == -1 && productHandle != "undefined.js") {
      array.push(productHandle);
  }
  //BG: Update localStorage
  localStorage.setItem("recentProducts", JSON.stringify(array));

}

//BG: Using localStorage, we create an array based on the products the user has been viewing. When they visit a product page, it stores the product handle. 
function recentlyViewedProducts() {
    //Retrieve localstorage for recentproducts(if it exists)
    var savedRecentProducts = JSON.parse(localStorage.getItem("recentProducts")),
        outputLocation = ".product-recently-viewed",
        newProduct = $(outputLocation).attr('data-product-handle');
        newProduct = newProduct + ".js",
        maxProducts = 6;

    //if localstorage exists, retrieve the list and output it
    if (savedRecentProducts) {
        retrieveRecentlyViewedProducts(savedRecentProducts,outputLocation,maxProducts);
        addNewProduct(savedRecentProducts,newProduct,maxProducts);
    } else {
        //First time user has visited a product page, so let's create the new local storage.
        //console.log('doesn\'t exist, let\'s make a new array');
        var recentProducts = [];
        addNewProduct(recentProducts,newProduct,maxProducts);
    }
}

recentlyViewedProducts();
//BG: If the user changes the variant, update the hidden variant input with the new ID.
function quickviewVariant() {
    var variantDesktop = $('.product-quickview-frame .product-variants.desktop li:not(.not-available)'),
        variantMobile = $('.product-quickview-frame select.product-variants.mobile'),
        variantInput = $('.product-quickview-frame .product-variant-id');
    
    
    variantDesktop.on('click',function() {
        var variantID = $(this).attr('data-variant-id');
        variantDesktop.removeClass('active');
        $(this).addClass('active');

        variantInput.attr('value',variantID);
    });

    variantMobile.on('change', function () {
        var variantID = $(this).val(); 
        variantInput.attr('value',variantID);
    });

}


//init slickslider on quickview product imagery
function quickviewSlick() {
	$('.product-quickview-frame .product-detail-images').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots:false,
		prevArrow: slickPrevArrow,
		nextArrow: slickNextArrow,
		arrows: true,
		fade: true,
	});
}

function quickviewAddToBasket() {
	$('.product-quickview-frame .btn-add-to-cart').click(function(){
		
		$('.product-quickview-frame form').submit(function (e) {
			e.preventDefault();
			addToCart($(this));
		});

		setTimeout(function() {
			quickviewClose();
		}, 2500);
	});
}

//BG: Empty the quickview, and close it.
function quickviewClose() {
    $('.product-quickview-frame').removeClass('active');
    $('.product-quickview-overlay').removeClass('active');
    $('.product-quickview-frame .product-frame').html('');
    $('html,body').removeClass('quickview-open');
}

//BG: On change, send the user to the colour product option they have selected.
function quickviewColourSelect() {
    $('.product-quickview-frame .product-frame .product-colours-container select.product-colours.mobile').on('change', function () {
        var url = $(this).val(); 
        if (url) { 
            window.location = url; 
        }
        return false;
    });
}

function quickviewColourSwatch(currentProductColour, colourGroupName) {
    $.ajax({
        type: 'GET',
        url: '/collections/all/' + colourGroupName + '?view=colour',
        success: function (data) {
            if(data) {
                try {
                    var json = JSON.parse(data);
                } catch(e) {
                    var json = null; // meh
                }
            }
            //if JSON is present then output the results.
            if (json) {

            var productColourContainer = '<div class="product-colours-container"><h3 class="selected-colour"><span class="label">Colour:</span><span class="value">'+currentProductColour+'</span></h3>';

            var listMarkup = '<ul class="product-colours desktop">',
                selectMarkup = '<select class="product-colours mobile">';
        
            //for each product
            for (var key in json.products) {
                var productColour = json.products[key]['colour'],
                    productURL = json.products[key]['url'],
                    productID = json.products[key]['id'],
                    activeClass = "",
                    selected = "";

                //if current product ID matches the product ID in the loop, set active class and selected option.    
                if (productColour === currentProductColour) {
                    activeClass = " current";
                    selected = ' selected="selected"';
                }
        
                //Add option product to the list and select markup
                listMarkup += '<li><a href="'+productURL+'" class="'+productColour.toLowerCase()+''+activeClass+'">'+productColour+'</a></li>';
                selectMarkup += '<option value="'+productURL+'"'+selected+'>'+productColour+'</option>';
        
            }
        
            //close list and select markup
            listMarkup += '</ul>';
            selectMarkup += '</select>';

            productColourContainer += listMarkup;
            productColourContainer += selectMarkup;
            productColourContainer += '</div>';

            //output the results to the product quickview frame.
            $('.product-quickview-frame .product-frame .product-variant-container').before(productColourContainer);
            quickviewColourSelect();
        
            }
        }
    });
}

//BG: take the data from the ajax request, and create the markup. 
function quickviewMarkup(data, quickViewProduct) {
    //console.log(data);
    var product = data.product[0];

    //LETS CONSTRUCT THE QUICKVIEW POPUP

    //COMPARE AT PRICE (SALE PRICE)
    var productComparePrice = '';
    if (product['variants'][0]['compare_at_price'] != "" ) {
        productComparePrice = '<span class="product-price-original"><span class="money">' + slate.Currency.formatMoney(product['variants'][0]['compare_at_price'], theme.moneyFormat) + '</span></span>';
    }

    //slate.Currency.formatMoney(product['variants'][0]['price'], theme.moneyFormat)

    //PRODUCT VARIANTS
    //BG: Desktop and Mobile styling for the variants (sizes) are different, hence the variables below. we output both and then show/hide the one we need.
    var productVariantDesktop = '<ul class="product-variants desktop">';
    var productVariantMobile = '<select class="product-variants mobile">';
    var firstVariant = true;
    var firstAvailableVariantID = '';

    //for each product variant..
    for (var key in product['variants']) {
        var variant = product['variants'][key],
            firstVariantClass = '',
            firstSelected = '',
            disabled = '';

        //BG: This is unique to the 'view=json' url paramater method we use. It can't be accessed via the standard product.json method. 
        if (variant['available'] == 'true') {
            var variantStatus = 'available';

            //Find the first available variant and highlight it by default
            if (firstVariant) {
                firstVariantClass = ' active';
                firstSelected = ' selected="selected"';
                firstVariant = false;
                firstAvailableVariantID = variant['id'];

            }
        } else {
            var variantStatus = 'not-available';
            disabled = ' disabled';
        }

        //Add to desktop markup
        productVariantDesktop += '<li class="'+variantStatus+''+firstVariantClass+'" data-variant-id="'+variant['id']+'">'+ variant['title'] +'</li>';
        productVariantMobile += '<option value="'+variant['id']+'"'+firstSelected+''+disabled+'>'+variant['title']+'</option>';
    }
    
    productVariantDesktop += '</ul>';
    productVariantMobile += '</select>';


    //PRODUCT IMAGES
    var productImages = '';
    //for each image...
    for (var key in product['images']) {
        var image = product['images'][key];

        productImages += '<div class="product-image"><img src="'+ image['src'] +'" class="img-fluid" alt="'+product['title']+'"></div>';
    }

    //if there are images available, display them, if not, default to SVG placeholder.
    if (productImages != '') {
        var productImageContainer = '<div class="product-detail-images">' + productImages + '</div>';
    } else {
        var productImageContainer = '<div class="product-detail-images empty">' + svgPlaceholder +'</div>';
    }

    //Build Markup output
    var quickviewHTML = '<div class="container product-detail-container quickview-product-details">' +
    '<div class="row align-items-center">' +
        '<div class="col-12 col-lg-6">' +productImageContainer + '</div><!-- Col - Image -->' +
    '<div class="col-12 col-lg-6">' +
        '<h3 class="product-title text-center"><a href="'+ product['handle']+'">'+ product['title'] +'</a></h3>' + 
        '<div class="row align-items-sm-center text-center">' +
        '<div class="col-12">' + 
            '<div class="product-detail-price-wrapper">' +
            '<span class="product-detail-price">' +
                '<span class="money">'+slate.Currency.formatMoney(product['variants'][0]['price'], theme.moneyFormat) + '</span>' +
            '</span>' +
            productComparePrice +
            '<form method="post" action="/cart/add">' +
            '<div class="product-variant-container variant-'+product['options'][0]['name'].toLowerCase() + '"><div class="swatch-header">'+ product['options'][0]['name'] +'</div>' +
            productVariantDesktop +
            productVariantMobile +
            '</div>'+
            '<input min="1" type="hidden" id="quantity" name="quantity" value="1" />' +
            '<input type="hidden" name="id" class="product-variant-id" value="'+ firstAvailableVariantID + '" />' +	
            '<button type="submit" name="add" data-add-to-cart="" class="btn-add-to-cart btn btn-primary mt-3 variant-available"><span data-add-to-cart-text="">Add to Bag</span></button>'+
            '</form>' +
        '</div><!-- col -->' +	
        '</div><!-- row -->' +
    '</div><!-- Col - Details -->' +

    '</div><!-- row -->' +
    '</div><!-- container -->';

    quickViewProduct.html(quickviewHTML);

    //Lets check to see if the colour swatch data returned, if there is, let's add the colour options.
    if (product['colour'] && product['group_colours']) {
        quickviewColourSwatch(product['colour'], product['group_colours']);
    } 
}

function quickViewNew() {

	var quickViewBtn = $('.product-quickview .btn'),
		quickViewFrame = $('.product-quickview-frame'),
		quickViewOverlay = $('.product-quickview-overlay'),
		quickViewClose = $('.product-quickview-frame .frame-close'),
		quickViewProduct = $('.product-quickview-frame .product-frame');

	quickViewBtn.off('click').on( "click", function() {
		var productURL = $(this).attr('data-product-url');

		quickViewFrame.addClass('active');
		quickViewOverlay.addClass('active');
        $('html,body').addClass('quickview-open');
        
		$.ajax({
            type: 'GET',
            //BG: changed from .json to '?view=json' instead, which is a powerful url parameter that changes the product template based on the value in the parameter. The 'product.json.liquid' template it loads, is setup to look like json, but means we can include additional stuff into the ajax request such as availability, metafields etc.
			url: productURL + '?view=json',
			success: function (data) {
                //console.log('ajax success');
                if(data) {
                    try {
                        var json = JSON.parse(data);
                    } catch(e) {
                        var json = null; // meh
                    }
                }
                if (json) {
                    quickviewMarkup(json,quickViewProduct)
                    quickviewSlick();
                    quickviewVariant();
                    quickviewAddToBasket();
                }
			}
		});

	});

	quickViewClose.click(function(){
		quickviewClose();
    });

    quickViewFrame.click(function(e){
        if(e.target !== e.currentTarget) return;

        quickviewClose();
    })
}

quickViewNew();
	/**
	 * Velstar Ajaxify Cart
	 **/
	var config = {

		/* Langauge */
		addToCartBtnText: 		'Add to Basket', //Add to Basket
		addedToCartBtnText: 	'Added to Basket', //Added to Basket
		addingToCartBtnText: 	'Adding', //Adding...
		soldOutBtnText: 		'Sold Out', //Sold Out
		//After adding a product to the cart, how long to wait before it returns to normal?
		returnBtnToNormal: 		4000, // milliseconds

		/* Selectors */
		cartCountSelector: 		'.cart-count',
		cartTotalSelector: 		'.mini-cart-total',
		cartRemoveSelector: 	'.cart-prod-remove',

		/* Icons*/
		successIcon: 			'<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-check" viewBox="0 0 512 512"><path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg>',
		errorIcon: 				'<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-times" viewBox="0 0 352 512"><path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path></svg>',
		loadingIcon: 			'<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-sync" viewBox="0 0 512 512"><path d="M500 8h-27.711c-6.739 0-12.157 5.548-11.997 12.286l2.347 98.575C418.212 52.043 342.256 8 256 8 134.813 8 33.933 94.924 12.296 209.824 10.908 217.193 16.604 224 24.103 224h28.576c5.674 0 10.542-3.982 11.737-9.529C83.441 126.128 161.917 60 256 60c79.545 0 147.942 47.282 178.676 115.302l-126.39-3.009c-6.737-.16-12.286 5.257-12.286 11.997V212c0 6.627 5.373 12 12 12h192c6.627 0 12-5.373 12-12V20c0-6.627-5.373-12-12-12zm-12.103 280h-28.576c-5.674 0-10.542 3.982-11.737 9.529C428.559 385.872 350.083 452 256 452c-79.546 0-147.942-47.282-178.676-115.302l126.39 3.009c6.737.16 12.286-5.257 12.286-11.997V300c0-6.627-5.373-12-12-12H12c-6.627 0-12 5.373-12 12v192c0 6.627 5.373 12 12 12h27.711c6.739 0 12.157-5.548 11.997-12.286l-2.347-98.575C93.788 459.957 169.744 504 256 504c121.187 0 222.067-86.924 243.704-201.824 1.388-7.369-4.308-14.176-11.807-14.176z"></path></svg>',


		/* No need to change this elements. */
		addToCartBtnSelector: 	'.btn-add-to-cart.variant-available',
		addToCartFormSelector: 	'form[action="/cart/add"]',
		shopifyAjaxAddURL: 		'/cart/add.js',
		shopifyAjaxChangeURL: 	'/cart/change.js',
		shopifyAjaxCartURL: 	'/cart.js'
	}

//Provide the user Feedback if the Ajax was sucessful or not.
function ajaxFeedback(status, html, $addToCartForm) {
	//$('.ajaxfeedback').remove();
	var feedback = '<p class="ajaxfeedback ' + status + '">' + html + '</p>';

	$addToCartForm.find(config.addToCartBtnSelector).after(feedback);
	$('.ajaxfeedback').slideDown();
}

//BG: Provide the user feedback on the cart template when adjusting quantity / variant.
function ajaxFeedbackCart(status,html,output) {
	$('.ajaxFeedbackCart').remove();
	var feedback = '<span class="ajaxFeedbackCart '+status+'">'+html+'</span>';

	$(output).after(feedback);
}

//BG: Used on Cart Page
function updateCartTotal() {
    $.ajax({
		type: 'GET',
		url: config.shopifyAjaxCartURL,
		dataType: 'json',
		success: function (data) {

            //Remaining need to qualify for free delivery
            var deliveryThreshold = 3000,
                remainingAmount = deliveryThreshold - data.total_price,
                remainingAmountFormat = slate.Currency.formatMoney(remainingAmount, theme.moneyFormat);

            // standard delivery is £1.99 and free delivery over £30.
            if (data.total_price >= 3000) {
                var deliveryCost = 0;
                // user has qualified for free delivery
                $('.free-delivery-banner').html('<p>You qualify for free delivery</p>');
            } else {
                var deliveryCost = 199;
                //output the remaining amount needed to qualify for free delivery
                $('.free-delivery-banner').html('<p>Spend <span class="money">'+remainingAmountFormat+'</span> or more to qualify for free delivery</p>');
            }

            /* Create the following variables:
                Subtotal = cart total without estimated delivery price
                totalFormat = cart total with estimated delivery price
            */
            var subTotal = slate.Currency.formatMoney(data.total_price, theme.moneyFormat),
                totalWithDelivery = data.total_price + deliveryCost,
                deliveryFormat = slate.Currency.formatMoney(deliveryCost, theme.moneyFormat),
                totalFormat = slate.Currency.formatMoney(totalWithDelivery, theme.moneyFormat);

            //Update cart page
            $('.basket-price-row .basket-total-value span').text(subTotal);
            $('.basket-price-row .estimated-delivery span').text(deliveryFormat);
            $('.basket-price-row .basket-grand-total span').text(totalFormat);

            //update mini cart
            $('.mini-cart-totalshipping span').text(subTotal);

		}
	});
}

//Update the button apperance during the various stages. Adding, added, and back to add.
function updateBtnText($button, label, icon) {
	if ($button.children().length) {
		$button.children().each(function () {
			if (icon) {
				if ($.trim($(this).text()) !== '') {
					$(this).html(label + icon);
				}
			} else {
				if ($.trim($(this).text()) !== '') {
					$(this).text(label);
				}
			}
		});
	} else {
		$button.val(label).text(label);
	}
}


//BG: Update the select options on the mini cart.
function updateMiniCartQuantitySelect() {
    var miniCartRow = $('.header-basket .cart-row .cart-item');

    miniCartRow.each(function(){
        var cartRowQuantitySelect = $(this).find('.cart-item-quantity-select'),
            cartRowQuantityValue = $(this).find('.cart-item-quantity-value').attr('value');

            cartRowQuantitySelect.find('[value="'+cartRowQuantityValue+'"]').attr('selected', true);
    });
}


//BG: Function to update the Cart Dropdown with the newly added product(s)	
function updateMiniCartContents() {

	//ajax get request to cart.js
	$.ajax({
		type: 'GET',
		url: config.shopifyAjaxCartURL,
		dataType: 'json',
		success: function (data) {

			//Debug
			console.log(data);

			//Get Cart Total Cost (format it) & Cart Count. 
			var cartTotalCost = slate.Currency.formatMoney(data.total_price, theme.moneyFormat),
				cartCount = data.item_count;

			//Output cart total
			$(config.cartTotalSelector).text(cartTotalCost);
			$(config.cartCountSelector).text(cartCount);
			if (cartCount > 0) {
				$(config.cartCountSelector).removeClass('no-items');
			} else {
				$(config.cartCountSelector).addClass('no-items');
			}


			//remove all items within cart.
			$('.cart-mini-contents .cart-row .cart-item').remove();

			//with the returned data, focus soley on the items. For each item...
        //with the returned data, focus soley on the items. For each item...
        $.each(data.items, function (i, item) {
            //debugging
            //console.log(item);

            var itemTitle = item.product_title;
            var itemPrice = slate.Currency.formatMoney(item.price, theme.moneyFormat);
            var itemQuantity = item.quantity;
            var itemVariant = item.variant_title;
            var itemVariantId = item.variant_id;
            var itemImage = item.image;
            var itemUrl = item.url;
            var optionName = item.options_with_values[0]['name'];
            var optionValue = item.options_with_values[0]['value'];

            if (itemImage) {
                itemImageHTML = '<img src="' + itemImage + '" class="img-fluid">';
            } else {
                itemImageHTML = svgPlaceholder;
            }
            
            var cartContents = '' +
                '<div class="cart-item">' + 
                    '<div class="cart-item-left">' +
                        '<div class="cart-prod-img">' +
                            '<a href="' + itemUrl + '">' +
                                itemImageHTML + 
                            '</a>' + 
                        '</div>' +
                    '</div>' +
                    '<div class="cart-item-right">' +
                        '<div class="cart-prod-name">' +
                            '<a href="' + itemUrl + '">' + itemTitle + '</a>' + 
                        '</div>' +
                        '<div class="cart-prod-size">' +
                            '<span class="label">'+ optionName +':</span>' + 
                            '<span class="value">'+ optionValue +'</span>' + 
                        '</div>' +
                        '<div class="cart-item-quantity" data-variant-id="'+itemVariantId+'">' +
                            '<select class="cart-item-quantity-select" data-variant-id="'+itemVariantId+'">' +
                                '<option value="1">Qty: 1</option>' +
                                '<option value="2">Qty: 2</option>' + 
                                '<option value="3">Qty: 3</option>' +
                                '<option value="4">Qty: 4</option>' +
                                '<option value="5">Qty: 5</option>' +
                                '<option value="6">Qty: 6</option>' +
                                '<option value="7">Qty: 7</option>' +
                                '<option value="8">Qty: 8</option>' +
                                '<option value="9">Qty: 9</option>' +
                                '<option value="10">Qty: 10</option>' +
                            '</select>' +
                            '<span class="cart-item-quantity-label">Quantity</span>' +
                            '<input type="hidden" name="updates[]" id="updates_'+itemVariantId+'" class="cart-item-quantity-value" value="'+itemQuantity+'" />' +
                            '<div class="cart-prod-price">' +
                                '<span class="money">' + itemPrice + '</span>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="cart-prod-remove">' +
                            '<span data-variant-id="' + itemVariantId + '">Remove</span>' +
                    '</div>' +
                '</div>';

            //add each product back to mini cart preview.
            $('.cart-mini-contents .cart-row').append(cartContents);

        });

			//re-trigger the remove functionality.
            removeCartItemTrigger();
            miniCartQuantityChange();
            updateMiniCartQuantitySelect();
            updateCartTotal();
		}
	});
}

//remove product by setting quantity to zero via the data attribute.
function removeItemFromCart(variant_id) {
	//ajax get request to cart.js
	$.ajax({
		type: 'POST',
		url: config.shopifyAjaxChangeURL,
		data: 'quantity=0&id=' + variant_id,
		dataType: 'json',
		success: function (data) {

			//console.log('Remove Item Triggered');
			
			//Update the cart to reflect new contents.
			updateMiniCartContents();

		},
		error: function (XMLHttpRequest) {
			var response = eval('(' + XMLHttpRequest.responseText + ')');
			response = response.description;
			console.log(response);

		}
	});
}


//BG: Function will trigger on the cart page if user changes variant
function addItem(variant_id,quantity,old_variant_id) {
	$.ajax({
		type: 'POST',
		url: config.shopifyAjaxAddURL,
		data: 'quantity='+quantity+'&id=' + variant_id,
		dataType: 'json',
		success: function (data) {
            ajaxFeedbackCart('success','Updated size','.basket-item[data-variant-id='+old_variant_id+'] .product-variant-select');
            updateCartTotal();
		},
		error: function (XMLHttpRequest) {
			var response = eval('(' + XMLHttpRequest.responseText + ')');
			response = response.description;
		}
	});
}

//BG: function can be triggered by Quantity update, or variant update.
function quantityItemChange(variant_id,value,addProduct,new_variant_id,quantity) {
	//convert string to int
	var variant_id = parseInt(variant_id);

	//ajax get request to cart.js
	$.ajax({
		type: 'POST',
		url: config.shopifyAjaxChangeURL,
		data: 'quantity='+value+'&id=' + variant_id,
		dataType: 'json',
		success: function (data) {

            if (addProduct == 'minicart') {
                //Get Cart Total Cost (format it) & Cart Count. 
                var cartTotalCost = slate.Currency.formatMoney(data.total_price, theme.moneyFormat),
                    cartCount = data.item_count;
    
                //Output cart total
                $(config.cartTotalSelector).text(cartTotalCost);
                $(config.cartCountSelector).text(cartCount);
                if (cartCount > 0) {
                    $(config.cartCountSelector).removeClass('no-items');
                } else {
                    $(config.cartCountSelector).addClass('no-items');
                }

                updateCartTotal();
            }

			if (addProduct == 'add') {
				addItem(new_variant_id,quantity,variant_id);
			} else {
				$.each(data.items, function(index,item) {
					if (variant_id === item.variant_id) {
						if (item.quantity == value) {
                            if (addProduct == 'minicart') {
                                updateMiniCartQuantitySelect();
                                ajaxFeedbackCart('success','Updated','.cart-item-quantity[data-variant-id='+variant_id+'] .cart-item-quantity-label');
                            } else {
                                ajaxFeedbackCart('success','Quantity updated','.basket-item[data-variant-id='+variant_id+'] .product-quantity-select');
                            }

						//BG: if the amount has changed, but not to the value the user wanted.
						} else if (item.quantity < value) {
                            if (addProduct == 'minicart') {
                                updateMiniCartQuantitySelect();
                                ajaxFeedbackCart('warning','Failed','.cart-item-quantity[data-variant-id='+variant_id+'] .cart-item-quantity-label');
                            } else {
                                ajaxFeedbackCart('warning','Quantity Updated to '+item.quantity+'. This is the last remaining amount.','.basket-item[data-variant-id='+variant_id+'] .product-quantity-select');
                            }
						}
						return false
					}
                });
                updateCartTotal();
            }
			
		},
		error: function (XMLHttpRequest) {
			var response = eval('(' + XMLHttpRequest.responseText + ')');
			response = response.description;
		}
	});
}




//Define the remove cart item selector, use the .off & .on feature to ensure it works correctly after new contents added to mini cart.
function removeCartItemTrigger() {
	//Remove Item from Cart
	$(config.cartRemoveSelector + ' span').off().on("click", function () {
		var varientID = $(this).attr('data-variant-id');

		$(this).parents('.cart-item').slideUp();
		
		//Pass over to removeItemFromCart Function.
		removeItemFromCart(varientID);

	});
}

function addToCart(form) {
		$('.ajaxfeedback').remove();
		//e.preventDefault();
		var $addToCartForm = form;
		var $addToCartBtn = $addToCartForm.find(config.addToCartBtnSelector+':first-of-type');

		//Adding button stage
		updateBtnText($addToCartBtn, config.addingToCartBtnText, config.loadingIcon);
		$addToCartBtn.addClass('btn-adding').prop('disabled', true);

		// Add to cart.
		$.ajax({
			url: config.shopifyAjaxAddURL,
			dataType: 'json',
			type: 'post',
			data: $addToCartForm.serialize(),
			success: function (itemData) {

				//Added button stage
				updateBtnText($addToCartBtn, config.addedToCartBtnText, config.successIcon);
				$addToCartBtn.removeClass('btn-adding').addClass('btn-added');

				//Once added, reset button back to add.
				window.setTimeout(function () {
					$addToCartBtn.prop('disabled', false).removeClass('btn-added');
					updateBtnText($addToCartBtn, config.addToCartBtnText);
				}, config.returnBtnToNormal);

				updateMiniCartContents();

				window.setTimeout(function () {

                    $('.header-basket > a').addClass('active');
                    $('.cart-mini-contents').addClass('active');
                    $('.nav-overlay').addClass('active');

				}, 1000);

				window.setTimeout(function () {
					$('.header-basket > a').removeClass('active');
                    $('.cart-mini-contents').removeClass('active');
                    $('.nav-overlay').removeClass('active');

				}, 4000);
				
			},
			error: function (XMLHttpRequest) {
				var response = eval('(' + XMLHttpRequest.responseText + ')');
				response = response.description;
				if (response.slice(0, 4) === 'All ') {
					ajaxFeedback('error', response.replace('All 1 ', 'All '), $addToCartForm);
					$addToCartBtn.prop('disabled', false);
					updateBtnText($addToCartBtn, config.soldOutBtnText);
					$addToCartBtn.prop('disabled', true).removeClass('btn-adding').removeClass('btn-added');
				} else {
					ajaxFeedback('error', '<i class="fa fa-warning"></i> ' + response, $addToCartForm);
					$addToCartBtn.prop('disabled', false).removeClass('disabled');
					updateBtnText($addToCartBtn, config.addToCartBtnText);
				}

			}

		});
		return false;
}



//BG: allows the user to update the quantity and/or variant on the cart page.
function cartItemQuantityVariant() {
	var cartItem = $('.basket-item');

	cartItem.each(function(){
		var variantSelect = $(this).find('.product-variant-select'),
			variantSelectValueOriginal = '',
			quantitySelect = $(this).find('.product-quantity-select'),
			quantitySelectId = quantitySelect.attr('data-variant-id'),
			quantitySelectValue = quantitySelect.val();

		variantSelect.on('focus', function(){
			variantSelectValueOriginal = $(this).val();
		});

		variantSelect.on('change', function(){
			var variantSelectValue = $(this).val();
			quantitySelectId = quantitySelect.attr('data-variant-id',variantSelectValue);
            //console.log('original value: ' + variantSelectValueOriginal);
			//console.log('selected value: ' + variantSelectValue);

			quantityItemChange(variantSelectValueOriginal,0,'add',variantSelectValue,quantitySelectValue);

		});

		quantitySelect.on('change',function(){
			quantitySelectValue = $(this).val();
			quantitySelectId = quantitySelect.attr('data-variant-id');
			quantityItemChange(quantitySelectId,quantitySelectValue);
		})	
	});
}

function miniCartQuantityChange() {
    var miniCartRow = $('.header-basket .cart-row .cart-item');
    miniCartRow.each(function(){
        var cartRowQuantitySelect = $(this).find('.cart-item-quantity-select');
        
        cartRowQuantitySelect.off('change');

        cartRowQuantitySelect.on('change',function(){
            quantitySelectValue = $(this).val();
            quantitySelectId = $(this).attr('data-variant-id');
            quantityItemChange(quantitySelectId,quantitySelectValue,'minicart');
        })	

    });
}



$(document).ready(function() {

	if ($('body').hasClass('template-cart')) {
        cartItemQuantityVariant();
	}
	
    removeCartItemTrigger();
    miniCartQuantityChange();
    updateMiniCartQuantitySelect();
	
	$(config.addToCartFormSelector).submit(function (e) {
		e.preventDefault();
		addToCart($(this));
    });
    
});


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});

/* ==========================================================================
#Custom Velstar
========================================================================== */


//product page swatch change
$('.swatch :radio').change(function() {
	var optionIndex = $(this).closest('.swatch').attr('data-option-index');
	var optionValue = $(this).val();
	$(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
});